import { render, staticRenderFns } from "./RefsContract.vue?vue&type=template&id=41242587&scoped=true"
import script from "./RefsContract.vue?vue&type=script&lang=ts"
export * from "./RefsContract.vue?vue&type=script&lang=ts"
import style0 from "./RefsContract.vue?vue&type=style&index=0&id=41242587&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41242587",
  null
  
)

export default component.exports